(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequirefdb2"];
parcelRequire.register("h6J0t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c745e894748cd3c6$export$2e2bcd8739ae039; });

var $lzkzF = parcelRequire("lzkzF");

var $hOFnS = parcelRequire("hOFnS");

var $bm5yR = parcelRequire("bm5yR");
var $c745e894748cd3c6$export$2e2bcd8739ae039 = function() {
    var cardCarousels = document.getElementsByClassName("js-card-slider");
    if (!cardCarousels) return;
    Array.from(cardCarousels).forEach(function(carousel) {
        var _carousel_dataset, _carousel_dataset1;
        // Only show 2 if there's only two
        var totalSlides = carousel.querySelectorAll(".splide__slide").length;
        var maxSlides = Math.min(totalSlides, 3);
        if (totalSlides <= 1) return;
        var _carousel_dataset_type;
        var type = (_carousel_dataset_type = carousel === null || carousel === void 0 ? void 0 : (_carousel_dataset = carousel.dataset) === null || _carousel_dataset === void 0 ? void 0 : _carousel_dataset.type) !== null && _carousel_dataset_type !== void 0 ? _carousel_dataset_type : "slide";
        var _carousel_dataset_perPage;
        var perPage = (_carousel_dataset_perPage = carousel === null || carousel === void 0 ? void 0 : (_carousel_dataset1 = carousel.dataset) === null || _carousel_dataset1 === void 0 ? void 0 : _carousel_dataset1.perPage) !== null && _carousel_dataset_perPage !== void 0 ? _carousel_dataset_perPage : maxSlides;
        var splide = new (0, $lzkzF.default)(carousel, {
            type: type,
            perPage: perPage,
            gap: "16px",
            pagination: false,
            drag: totalSlides > maxSlides,
            breakpoints: {
                1060: {
                    perPage: 2,
                    drag: totalSlides > 2
                },
                760: {
                    perPage: 1,
                    drag: totalSlides > 1,
                    focus: "center"
                }
            }
        });
        splide.mount();
        // Recalculate the overflow fade width
        (0, $hOFnS.setCarouselCssVar)(carousel);
    });
    // Recalculate the overflow fade width
    window.addEventListener("resize", (0, $bm5yR.throttle)(250, function() {
        Array.from(cardCarousels).forEach(function(carousel) {
            (0, $hOFnS.setCarouselCssVar)(carousel);
        });
    }));
};

});
parcelRequire.register("hOFnS", function(module, exports) {

$parcel$export(module.exports, "setCarouselCssVar", function () { return $cf873534ff153130$export$5678847c08546352; });
// Calcuates the width of an item so we can use a mask to fade out the edges
var $cf873534ff153130$export$5678847c08546352 = function(carousel) {
    var slideWidth = carousel.querySelector(".splide__slide").clientWidth;
    carousel.parentElement.style.setProperty("--slideWidth", "".concat(slideWidth, "px"));
};

});


})();
//# sourceMappingURL=card-sliders.efff989b.js.map
